import { Component, OnInit } from '@angular/core';
import { IBillingDocument, IBillingBalance } from '@dch/billing-business-logic';
import { UtilsService } from '../services/utils.service';
import { SelectedOdbDetailsInfo } from '../models/pii.model';

@Component({
  selector: 'my-bill-options-payment-facilities-info-page',
  templateUrl: './bill-options-payment-facilities-info-page.component.html',
  standalone: false,
})
export class BillOptionsPaymentFacilitiesInfoPageComponent implements OnInit {
  selectedOdbDetailsInfo?: SelectedOdbDetailsInfo;
  billDocument?: IBillingDocument;
  customerPaymentProfile?: IBillingBalance['customerPaymentProfile'];

  constructor(private utilsService: UtilsService) {}

  ngOnInit() {
    const { billDocument, customerPaymentProfile } =
      this.utilsService.getDeferralDocumentInfoFromStorage();
    this.billDocument = billDocument;
    this.customerPaymentProfile = customerPaymentProfile;
  }
}
